import Bank from './bank';

export const BankConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : ['super', 'staff', 'outbound'],
    routes  : [
        {
            path     : '/bank',
            component: Bank
        }
    ]
};
